import React, { useState } from "react";
import {
  Grid,
  Container,
  IconButton,
  Card,
  Hidden,
  Paper,
  Typography,
  Avatar,
} from "@material-ui/core";
import WebStyles from "../../WebStyles.module.css";
import clsx from "clsx";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import { Link } from "react-router-dom";

const partnersList = [
  {
    websiteLink: "https://www.orea.com/",
    websiteLogo: "https://www.iheartradio.ca/image/policy:1.1892570:1473710761/Ontario-Real-Estate-Association.jpg?w=1000&$p$w=97990b0",
    padding: 0,
    width: 233,
    height: 149,
    xlUpWidth: 200,
    xlUpHeight: 200,
    xlUpPadding: 16,
  },
  {
    websiteLink: "https://www.mreb.ca/",
    websiteLogo: "https://www.mreb.ca/global/images/logo.png",
    padding: 4,
    width: 130,
    height: 130,
    xlUpWidth: 200,
    xlUpHeight: 200,
    xlUpPadding: 16,
  },
  {
    websiteLink: "https://www.bdar.ca/home",
    websiteLogo:
      "https://static.wixstatic.com/media/4d1951_25b430c5d5b840ad963c9866d962c8a4~mv2.png/v1/crop/x_297,y_204,w_982,h_375/fill/w_182,h_66,al_c,q_85,usm_0.66_1.00_0.01,enc_auto/ldsp_colour.png",
    padding: 22,
    width: 226,
    height: 100,
    xlUpWidth: 250,
    xlUpHeight: 135,
    xlUpPadding: 40,
  },
  // {
  //   websiteLink: "https://www.breb.org/",
  //   websiteLogo:
  //     "https://www.breb.org/mpower8OMDREB/cms2/boards/assets/images/logos/logo-breb.png",
  //   padding: 8,
  //   width: 170,
  //   height: 120,
  //   xlUpWidth: 250,
  //   xlUpHeight: 150,
  //   xlUpPadding: 28,
  // },
  {
    websiteLink: "https://realestatechathamkent.com/",
    // websiteLogo:
    //   "https://realestatechathamkent.com/wp-content/uploads/2015/10/chatham-kent-association-realtors-logo.png",
    websiteLogo: "/images/aboutus/realestatechathamkent.png",
    padding: 30,
    width: 200,
    height: 80,
    xlUpWidth: 260,
    xlUpHeight: 115,
    xlUpPadding: 55,
  },
  {
    websiteLink: "https://www.durhamrealestate.org/",
    websiteLogo:
      "https://durhamrealestate.org/includes/img/content-header-logo@2x.png",
    padding: 10,
    width: 200,
    height: 110,
    xlUpWidth: 250,
    xlUpHeight: 110,
    xlUpPadding: 55,
  },
  {
    websiteLink: "https://www.lstar.ca/",
    // websiteLogo: "https://www.lstar.ca/sites/all/themes/lstar/logo.png",
    websiteLogo: "https://www.lstar.ca/sites/default/files/lstar-logo-new.png",
    padding: 15,
    width: 200,
    height: 110,
    xlUpWidth: 250,
    xlUpHeight: 120,
    xlUpPadding: 52,
  },
  {
    websiteLink: "https://www.rahb.ca/",
    websiteLogo:
      "https://www.rahb.ca/wp-content/uploads/2018/10/RAHB-logo_hztrans_video.png",
    padding: 10,
    width: 210,
    height: 120,
    // xlUpWidth: 250,
    xlUpHeight: 102,
    xlUpPadding: 62,
  },
  {
    websiteLink: "https://homedepositsnow.com/",
    websiteLogo:
      "data:image/png;base64,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",
    // websiteLogo:
    //   "https://www.google.com/imgres?imgurl=https%3A%2F%2Fs3-us-west-2.amazonaws.com%2Fcbi-image-service-prd%2Fmodified%2F8c09d1c2-f785-4bd7-bcb4-83a4a0517611.png&imgrefurl=https%3A%2F%2Fwww.cbinsights.com%2Fcompany%2Fdeposit-rocket&tbnid=aJ23iq6U35SvFM&vet=12ahUKEwj3o5ymjpn5AhUqLrcAHWKQBksQMygAegUIARC7AQ..i&docid=zIgbaqRGqVXb8M&w=991&h=130&q=deposit%20rocket&ved=2ahUKEwj3o5ymjpn5AhUqLrcAHWKQBksQMygAegUIARC7AQ",
    padding: 44,
    width: 220,
    height: 50,
    xlUpWidth: 270,
    xlUpHeight: 50,
    xlUpPadding: 82,
  },
  {
    websiteLink: "https://www.brrea.com/",
    websiteLogo:
      "https://www.brrea.com/uploads/b/f831aa10-57ef-11ea-b337-7dfea682acb6/BRREA%20Logo.png?width=400",
    padding: 10,
    width: 220,
    height: 100,
    xlUpWidth: 250,
    xlUpHeight: 120,
    xlUpPadding: 32,
  },
  {
    websiteLink: "https://windsorrealestate.com/",
    websiteLogo:
      "https://windsorrealestate.com/wp-content/uploads/2019/05/logowecar-01.png",
    padding: 0,
    width: 142,
    height: 150,
    xlUpWidth: 190,
    xlUpHeight: 210,
    xlUpPadding: 12,
  },
  {
    websiteLink: "https://www.rentalsfornewcomers.com/",
    websiteLogo:
      "https://storage.googleapis.com/prepare-for-canada/logos/full/logo-renters-for-newcomers.png",
    padding: 30,
    width: 220,
    height: 80,
    xlUpWidth: 260,
    xlUpHeight: 90,
    xlUpPadding: 66,
  },
  {
    websiteLink: "https://www.tenantcube.com/",
    websiteLogo:
      "https://uploads-ssl.webflow.com/61eb0143d553053fc8c7c045/61f1b8458ff9c6955e7e5720_favicon-gradient.png",
    padding: 30,
    width: 80,
    height: 80,
    xlUpWidth: 260,
    xlUpHeight: 90,
    xlUpPadding: 66,
  },
  {
    websiteLink: "https://www.reccanada.com/",
    websiteLogo:
      "https://dtzulyujzhqiu.cloudfront.net/royallepagesignature3194/profiles/1601585687.png",
    padding: 30,
    width: 220,
    height: 80,
    xlUpWidth: 260,
    xlUpHeight: 90,
    xlUpPadding: 66,
  },
  {
    websiteLink: "https://www.prepareforcanada.com/",
    websiteLogo:
      "https://www.prepareforcanada.com/wp-content/uploads/PFC_Logo_with_Registered_TM-2.png",
    padding: 30,
    width: 220,
    height: 80,
    xlUpWidth: 260,
    xlUpHeight: 110,
    xlUpPadding: 66,
  },
  {
    websiteLink: "https://borrowell.com/",
    websiteLogo:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/6/63/Borrowell_logo_.jpg/1280px-Borrowell_logo_.jpg",
    padding: 30,
    width: 220,
    height: 80,
    xlUpWidth: 260,
    xlUpHeight: 110,
    xlUpPadding: 66,
  },
  {
    websiteLink: "https://agentichat.com/index.html",
    websiteLogo:
      "https://i.tracxn.com/logo/company/agentichat.com_Logo_0e7013e3-d75c-469a-a7ca-13a8d6507ea7.jpg?height=120&width=120",
    padding: "0px 30px 0px 30px",
    width: 120,
    height: 120,
    xlUpWidth: 260,
    xlUpHeight: 110,
    xlUpPadding: 66,
  },
  {
    websiteLink: "https://singlekey.com/en-ca/",
    websiteLogo:
      "https://platform.singlekey.com/static/main/singlekey_logo.png",
    padding: 30,
    width: 220,
    height: 80,
    xlUpWidth: 260,
    xlUpHeight: 110,
    xlUpPadding: 66,
  },
  {
    websiteLink: "https://www.datzsolutions.com/",
    websiteLogo:
      "https://images.crunchbase.com/image/upload/c_lpad,h_200,w_256,f_auto,q_auto:eco,dpr_1/tyrlbpakhfwcx6cm5vvi",
    padding: "0px 30px 0px 30px",
    width: 220,
    height: 150,
    xlUpWidth: 260,
    xlUpHeight: 110,
    xlUpPadding: 66,
  },
];

const isMobileDevice = () => {
  let check = false;
  (function (a) {
    if (
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
        a
      ) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
        a.substr(0, 4)
      )
    )
      check = true;
  })(navigator.userAgent || navigator.vendor || window.opera);
  return check;
};

function PartnersSection({ smUp, mdUp, lgUp, xlUp, commonPadding }) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const sliceFactor = lgUp ? 0 : mdUp ? 2 : 1;

  let formattedArray = sliceFactor
    ? partnersList.slice(currentIndex, currentIndex + sliceFactor)
    : partnersList;

  return (
    <Grid
      item
      container
      xs={12}
      style={{
        padding: commonPadding,
        backgroundImage:
          lgUp &&
          "url('/images/aboutus/purple_patch.svg'), url('/images/aboutus/blue_patch_right.svg')",
        backgroundRepeat: "no-repeat, no-repeat",
        backgroundPosition: "0% 25%,100% 87%",
        backgroundSize: "10%, 10%",
        top: 0,
        overflow: "auto",
      }}
    >
      <Container>
        <Grid
          container
          style={{
            marginTop: xlUp ? 142 : mdUp ? 105 : 51,
          }}
          justifyContent="center"
        >
          <Grid
            item
            xs={12}
            sm={12}
            lg={12}
            xl={12}
            className={clsx(WebStyles.captionViolet, WebStyles.hankrndFont)}
            style={{
              fontSize: xlUp ? 80 : mdUp ? 60 : 40,
              lineHeight: xlUp ? "74px" : mdUp ? "64px" : "42px",
              fontWeight: 600,
            }}
          >
            Our Partners
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            lg={12}
            xl={12}
            className={clsx(WebStyles.barlowFont)}
            style={{
              marginTop: xlUp ? 23 : mdUp ? 11 : 16,
              fontSize: mdUp ? 28 : 14,
              lineHeight: "38px",
            }}
          >
            Meet some associations we partner with
          </Grid>
        </Grid>

        <Grid
          container
          xs={12}
          style={{
            marginTop: 40,
            paddingLeft: !isMobileDevice() && 16,
          }}
          justifyContent="center"
        >
          <Paper variant="outlined" style={{ padding: 20 }}>
            <Grid container>
              <Grid item xs={12} md={8}>
                <Typography
                  align="left"
                  variant="h6"
                  style={{ fontWeight: "bold" }}
                  className={clsx(WebStyles.barlowFont)}
                >
                  {/* "At MREB, our policy is ‘members first’ and we are constantly
                  exploring tools and technology to make our members profitable
                  and productive. I am pleased to announce that Souqh’s
                  centralized homeownership hub is now available to all MREB
                  members, enabling them to deliver a seamless client
                  experience, grow their bottom line, work more efficiently with
                  clients and partners, increase their productivity and retain
                  long-term relationships with clients.” */}
                  "At OREA, our mission centers around providing our Members with cutting-edge tools to serve their clients effectively. Souqh addresses a longstanding void by unifying the homeownership experience for Canadians. As a pioneering move, OREA is the first provincial association to offer the Souqh homeownership hub to all Members as a valuable affinity benefit."
                </Typography>
                <Typography
                  align="left"
                  variant="subtitle1"
                  style={{ fontWeight: "bold", marginTop: 10 }}
                  className={clsx(WebStyles.barlowFont)}
                >
                  {/* Ray Dubash, */}
                  TANIA ARTENOSI
                </Typography>
                <Typography align="left" className={clsx(WebStyles.barlowFont)}>
                  {/* CEO, Mississauga Real Estate Board */}
                  PRESIDENT, OREA
                </Typography>
                <Typography
                  align="left"
                  className={clsx(
                    WebStyles.barlowFont,
                    WebStyles.samonHeaderTxt
                  )}
                >
                  Souqh Premier Partner
                </Typography>
              </Grid>
              <Grid
                container
                item
                xs={12}
                md={4}
                style={{
                  justifyContent: "center",
                  // alignContent: "center"
                  paddingTop: isMobileDevice() && 16,
                }}
              >
                <Avatar
                  // alt="Ray Dubash"
                  alt="Tania Artenosi"
                  // src="https://www.mreb.ca/Users/MREBAdmin/Pics/3.jpg"
                  src="/images/home_page/tania.png"
                  style={{ width: 170, height: 170 }}
                />
              </Grid>
            </Grid>
          </Paper>
        </Grid>

        <Grid
          item
          xs={12}
          container
          style={{
            justifyContent: "center",
            paddingBottom: 40,
            marginTop: xlUp ? 105 : mdUp ? 56 : 31,
          }}
        >
          <Hidden lgUp>
            <Grid
              item
              xs={1}
              container
              style={{ alignItems: "center", justifyContent: "flex-start" }}
            >
              <ArrowBackIosIcon
                disabled={currentIndex < 1}
                onClick={() => {
                  if (currentIndex > 0) {
                    setCurrentIndex(currentIndex - 1);
                  }
                }}
                style={{
                  width: 36,
                  height: 36,
                  fontSize: 36,
                  cursor: currentIndex > 0 ? "pointer" : "default",
                  fill: "#B872AF",
                  opacity: currentIndex > 0 ? 1 : "0.5",
                }}
              />
            </Grid>
          </Hidden>
          <Grid
            item
            xs={10}
            md={10}
            sm={10}
            lg={12}
            xl={12}
            spacing={lgUp ? 4 : null}
            container
            style={{ justifyContent: "center" }}
          >
            {/* {formattedArray} */}
            {formattedArray.map((partner, index) => {
              return (
                <Grid
                  container
                  item
                  xs={12}
                  sm={5}
                  md={5}
                  lg={3}
                  key={index}
                  style={{ padding: "0px 16px" }}
                >
                  <Grid
                    container
                    direction="column"
                    style={{
                      marginBottom: xlUp ? 119 : mdUp ? 65 : 31,
                    }}
                  >
                    <Card
                      elevation={0}
                      style={{
                        padding: xlUp
                          ? "10px 20px"
                          : partner.websiteLink ===
                            "https://windsorrealestate.com/"
                          ? 0
                            : partner.websiteLink === "https://www.orea.com/" ? "0px 5px 0px 5px" : 5,
                        height: xlUp ? 250 : 150,
                        width: xlUp ? 274 : lgUp ? 235 : "98%",
                        // width: xlUp ? 274 : "100%",
                        border: "1px solid #E2E2E2",
                        borderRadius: 12,
                        // padding: 5,
                        // padding: xlUp ? 5 : 0,
                        cursor: "pointer",
                      }}
                      onClick={() => window.open(partner.websiteLink)}
                    >
                      <Grid
                        container
                        item
                        xs={12}
                        justifyContent="center"
                        style={{
                          padding: xlUp ? partner.xlUpPadding : partner.padding,
                        }}
                      >
                        <img
                          src={partner.websiteLogo}
                          alt={partner.websiteLink}
                          style={{
                            width: xlUp ? partner.xlUpWidth : partner.width,
                            height: xlUp ? partner.xlUpHeight : partner.height,
                          }}
                        />
                      </Grid>
                    </Card>
                  </Grid>
                </Grid>
              );
            })}
          </Grid>
          <Hidden lgUp>
            <Grid
              item
              xs={1}
              container
              style={{ alignItems: "center", justifyContent: "flex-end" }}
            >
              <ArrowForwardIosIcon
                onClick={() => {
                  if (currentIndex < partnersList.length - sliceFactor) {
                    setCurrentIndex(currentIndex + 1);
                  }
                }}
                style={{
                  width: 36,
                  height: 36,
                  fontSize: 36,
                  cursor:
                    currentIndex < partnersList.length - 3
                      ? "pointer"
                      : "default",
                  fill: "#B872AF",
                  opacity: currentIndex < partnersList.length - 3 ? 1 : "0.5",
                }}
              />
            </Grid>
          </Hidden>
        </Grid>
      </Container>
    </Grid>
  );
}

export default PartnersSection;
